import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PublicTrackingInitialState, PublicTrackingItemLoad } from './public-tracking-item.actions';
import { SetInitialStateFacade } from '../../../../common';
import { PublicTrackingItemState } from './public-tracking-item.state';
import {
  ItemTrackingContentType,
  PublicTrackingHandlingUnit,
  PublicTrackingItemModel,
} from '../models/public-tracking.model';

@Injectable({ providedIn: 'root' })
export class PublicTrackingItemFacade implements SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(PublicTrackingItemState.getLoaded);
  overview$: Observable<PublicTrackingItemModel> = this.store.select(PublicTrackingItemState.getItem);
  handlingUnits$: Observable<PublicTrackingHandlingUnit[]> = this.store.select(
    PublicTrackingItemState.getHandlingUnits,
  );

  constructor(private store: Store) {}

  loadAll({
    itemId,
    zipCode,
    trackingContentType,
    sapId,
  }: {
    itemId: string;
    zipCode?: string;
    trackingContentType?: ItemTrackingContentType | string;
    sapId?: string;
  }): void {
    this.store.dispatch(new PublicTrackingItemLoad({ itemId, zipCode, trackingContentType, sapId }));
  }

  setInitialState(): void {
    this.store.dispatch(new PublicTrackingInitialState());
  }

  clearState(): void {
    this.setInitialState();
  }
}
